import React from "react";

/**
 *
 * @param {children, color, classe} props
 * @returns h2 element
 */
const H2 = (props) => {
  const { children, color, classe } = props;

  let colorTitle;

  if (color === "primary") colorTitle = "text-primary";
  else colorTitle = "text-secondary";

  return (
    <h2
      className={`
            ${colorTitle}
            ${classe}
            font-nunito
            text-2xl font-extrabold leading-snug
            md:text-3xl
            lg:text-3xl
        `}
    >
      {children}
    </h2>
  );
};

export default H2;
